var map = {
	"./cs.json": [
		"9f28",
		"lang-cs-json"
	],
	"./de.json": [
		"bac1",
		"lang-de-json"
	],
	"./en.json": [
		"e312"
	],
	"./es.json": [
		"ef52",
		"lang-es-json"
	],
	"./fr.json": [
		"b16e",
		"lang-fr-json"
	],
	"./it.json": [
		"669f",
		"lang-it-json"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "8825";
module.exports = webpackAsyncContext;